/**************************************************
 * Nombre:       Formulario_Funnel
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, MailOutline, WhatsApp,CakeOutlined,BusinessOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";

const Formulario_Funnel = ({...props}) => {
    const {datosFormulario} = props


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                {datosFormulario && datosFormulario.includes('Nombre') &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                      requerido={'Campo requerido'}
                        />
                    </Grid>
                }

                {datosFormulario && datosFormulario.includes('Pais') &&
                    <Grid container size={{xs: 12, sm: 12, md: 6}}>
                        <IngresoSelect Icono={BadgeOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                       opciones={PAISESINDICATIVO.map((it) => it.nameES)}
                                       requerido={'Campo requerido'}
                        />
                    </Grid>
                }

                {datosFormulario && datosFormulario.includes('Celular') &&
                    <Grid container size={{xs: 12, sm: 12, md: 6}}>
                        <IngresoTexto Icono={WhatsApp} nombre={'Celular'} dato={'celular'} {...props}
                                       requerido={'Campo requerido'}
                        />
                    </Grid>
                }

                {datosFormulario && datosFormulario.includes('Ciudad') &&
                    <Grid container size={{xs: 12, sm: 12, md: 6}}>
                        <IngresoTexto Icono={BusinessOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}
                                      requerido={'Campo requerido'}
                        />
                    </Grid>
                }

                {datosFormulario && datosFormulario.includes('Edad') &&
                    <Grid container size={{xs: 12, sm: 12, md: 6}}>
                        <IngresoTexto Icono={CakeOutlined} nombre={'Edad'} dato={'edad'} {...props}
                                      requerido={'Campo requerido'}
                        />
                    </Grid>
                }

                {datosFormulario && datosFormulario.includes('Correo') &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <IngresoTexto Icono={MailOutline} nombre={'Correo Electronico'} dato={'correo'} {...props}
                                      requerido={'Campo requerido'}
                        />
                    </Grid>
                }


                {datosFormulario && datosFormulario.includes('Impresiones') &&
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <IngresoTexto lineas={4} nombre={'Impresiones o preguntas (opcional)'}
                                      dato={'impresiones'} {...props}
                        />
                    </Grid>
                }


            </Grid>

        </form>

    )

}
export default Formulario_Funnel